<template>
  <div
    v-if="
      screenSizeComposable.isLaptop.value ||
      screenSizeComposable.isTablet.value ||
      screenSizeComposable.isMobile.value
    "
  >
    <MegaMenuOpenButton @click="megaMenuStore.openMegaMenu()" />

    <MegaMenuMobile
      v-model:open="megaMenuStore.isMegaMenuOpen"
      :menu-items="menuItems"
      show-customer
      is-top-level
      @close-menu="megaMenuStore.closeMegaMenu()"
    />
  </div>
</template>

<script setup lang="ts">
import MegaMenuOpenButton from '@/partials/MegaMenuPartial/Partial/MegaMenuOpenButton.vue';
import { useScreenSizeComposable } from '@/composables/ScreenSizeComposable.ts';
import { useWindowSize } from '@vueuse/core';
import { onBeforeMount, watch } from 'vue';
import MegaMenuMobile from '@/partials/MegaMenuPartial/Partial/MegaMenuMobile.vue';
import { useMegaMenuStore } from '@/stores/MegaMenu/MegaMenuStore.ts';

const screenSizeComposable = useScreenSizeComposable();
const { width } = useWindowSize();
const megaMenuStore = useMegaMenuStore();
const menuItems = window.mega_menu;

onBeforeMount(screenSizeComposable.screenSizeCheck);

watch(
  () => width.value,
  () => {
    screenSizeComposable.screenSizeCheck();
  }
);
</script>
